import {Component, Inject, OnInit} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-description-editor',
  templateUrl: './description-editor.component.html',
  styleUrls: ['./description-editor.component.scss']
})
export class DescriptionEditorComponent implements OnInit {

  descriptions = [];

  editableTypes = [
    {
      display_name: 'Simple Text',
      value: 'text'
    },
    {
      display_name: 'HTML Content',
      value: 'html'
    },
    {
      display_name: 'Blockly XML',
      value: 'blockly_xml'
    },
  ];
  currentIndex = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DescriptionEditorComponent>) {
    if (this.data && this.data.descriptions) {
      this.descriptions = JSON.parse(JSON.stringify(this.data.descriptions));
    }

    if (this.data && this.data.editableTypes) {
      this.editableTypes = this.data.editableTypes;
    }
  }

  ngOnInit() {
  }

  changeCurrentDescriptionIndex(i) {
    this.currentIndex = i;
  }

  removeDescription(i) {
    this.descriptions.splice(i, 1);
    this.currentIndex = (i !== 0) ? (i - 1) : i;
  }

  addDescription() {
    this.descriptions.push({
      type: 'text',
      content: '<Edit content here>',
    });
    this.currentIndex = this.descriptions.length - 1;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.descriptions, event.previousIndex, event.currentIndex);
  }

  save() {
    this.dialogRef.close(this.descriptions);
  }
}
